"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersPage = void 0;
var Orders_1 = require("./Orders");
Object.defineProperty(exports, "OrdersPage", { enumerable: true, get: function () { return Orders_1.OrdersPage; } });
